import { createApp } from 'vue';
import './style.css';
import { createPinia } from 'pinia';
import { createRouter, createWebHashHistory } from 'vue-router';
import App from './App.vue';
import routes from './router';
import YouMeng from './utils/YouMeng';

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

const pinia = createPinia();
createApp(App).use(router).use(pinia).mount('#app');

YouMeng.initYoumeng();
YouMeng.initYoumengLog();
router.afterEach(() => {
  YouMeng.pushRecord({ title: import.meta.env.VITE_WECHAT_SHARE_TITLE });
});
